import { t } from "i18next";

import { SplitLayout } from "@/layouts";
import { HeaderTextBlock } from "@/components/Typography";
import { SignUpForm } from "@/components/Form";

const SignUp = () => {
  const renderLeftPanel = () => (
    <div className="md:mr-50">
      <HeaderTextBlock
        align="left"
        featureText={t("complyOnboarding.signup.left.header.feature")}
        headingText={t("complyOnboarding.signup.left.header.heading")}
        headingTextColor="white"
        descriptionText={t("complyOnboarding.signup.left.header.description")}
        descriptionTextColor="white"
      />
    </div>
  );

  const renderRightPanel = () => (
    <div className="mb-25 max-w-[360px] sm:mb-50 md:ml-70">
      <HeaderTextBlock
        align="left"
        featureText={t("complyOnboarding.signup.right.header.feature")}
        headingText={t("complyOnboarding.signup.right.header.heading")}
      />
      <SignUpForm onboardingFlow="COMPLY" />
    </div>
  );

  return (
    <SplitLayout
      isDark={true}
      leftPanel={renderLeftPanel()}
      rightPanel={renderRightPanel()}
      backgroundSplit="leftSkewed"
    />
  );
};
export default SignUp;
